import { useEffect, useState } from "react";
import { useAPI } from "@/contexts/APIContext";
import { useUserData } from "@/contexts/UserDataContext";
import { useToast } from "@chakra-ui/react";
import { useRouter } from "next/router";

const useClaimFreeCredits = () => {
  const api = useAPI();
  const toast = useToast();
  const router = useRouter();

  const { currentUser, userData, refreshUserData } = useUserData();

  const [loadingFree, setLoadingFree] = useState(false);
  const [claimedFreeSuccess, setClaimedFreeSuccess] = useState(false);

  const claimFreeCredits = async () => {
    setLoadingFree(true);

    try {
      await api.postUnprotected("users/free-credits", true);
      await refreshUserData();
      setClaimedFreeSuccess(true);
    } catch (e) {
      toast({
        title: "Error claiming free credits",
        description: e.reason,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }

    setLoadingFree(false);
  };

  useEffect(() => {
    if (router.query.claimFreeUnlock === "true" && !!currentUser && !!userData.type) {
      claimFreeCredits();
    }
  }, [router, userData]);

  return {
    loadingFree,
    setLoadingFree,
    claimedFreeSuccess,
    setClaimedFreeSuccess,
    claimFreeCredits,
  };
};

export default useClaimFreeCredits;
